/** Pure URL helpers for the anonymous paywall → Clerk → identified checkout trip. */

export function resumePaywallLeadId(search: string): string | null {
  return new URLSearchParams(search).get("resume_upgrade");
}

export function stripResumePaywallParam(search: string): string {
  const params = new URLSearchParams(search);
  params.delete("resume_upgrade");
  return params.toString();
}

export function buildPaywallAuthHref(args: {
  path: "/sign-up" | "/sign-in";
  draftId?: string | null;
  leadId?: string;
}): string {
  const params = new URLSearchParams();
  if (args.draftId) params.set("restore", args.draftId);
  if (args.leadId) params.set("upgrade", args.leadId);
  const query = params.toString();
  return query ? `${args.path}?${query}` : args.path;
}
